import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Users } from "lucide-react";
import { adminApi, errorMessage } from "../../lib/api";
import { LocationPicker } from "../landing/LocationPicker";

export const EmployeeStats = () => {
  const [f, setF] = useState({ state: "", district: "" });
  const [data, setData] = useState(null);
  const load = useCallback(() => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    adminApi.get("/employer/employee-stats", { params }).then((r) => setData(r.data)).catch((e) => toast.error(errorMessage(e)));
  }, [f]);
  useEffect(() => { load(); }, [load]);
  if (!data) return null;
  return (
    <section data-testid="employee-stats" className="space-y-4">
      <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-white"><Users className="h-5 w-5 text-orange-400" />Available employees
        <span className="text-base font-normal text-slate-500" data-testid="employee-stats-total">({data.total} KYC verified)</span></h2>
      <div className="grid grid-cols-1 gap-4 rounded-2xl border border-white/10 bg-[#0F172A] p-5 sm:grid-cols-2">
        <LocationPicker prefix="emp-stats" state={f.state} district={f.district} onChange={(s, d) => setF({ state: s, district: d })} />
        {(f.state || f.district) && <button onClick={() => setF({ state: "", district: "" })} data-testid="employee-stats-clear" className="justify-self-start text-sm font-semibold text-orange-500 hover:underline sm:col-span-2">Show all places</button>}
      </div>
      {data.departments.length === 0 && <p data-testid="employee-stats-empty" className="py-6 text-center text-slate-500">No KYC-verified employees in this area yet.</p>}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {data.departments.map((d) => (
          <article key={d.department} data-testid={`employee-stats-${d.department}`} className="rounded-2xl border border-white/10 bg-[#0F172A] p-5">
            <div className="flex items-start justify-between gap-2">
              <p className="font-semibold text-white">{d.label}</p>
              <span className="shrink-0 rounded-full bg-emerald-500/10 px-2.5 py-0.5 text-sm font-bold text-emerald-500">{d.total}</span>
            </div>
            <ul className="mt-3 space-y-1.5 text-sm">
              {d.roles.map((r) => (
                <li key={r.job_role} className="flex justify-between gap-2 border-b border-white/5 pb-1 text-slate-400"><span>{r.job_role}</span><b className="text-white">{r.count}</b></li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
};
